import { reducePanDomain } from '../../../../core/components/interactions-state-helpers/reducers/pan-reducers.js';
import { getNextPanDomain } from '../../../../core/components/zoom/utils/get-next-pan-domain.js';
import { useSetState } from '../../../hooks/store/state-setters.js';
import { useHistogramInteractions } from '../../../hooks/useHistogramInteractions.js';
import { useHistogramXScale } from '../../../hooks/useHistogramXScale.js';
import { useInfiniteZoomConfig } from '../../../hooks/useInfiniteZoomConfig.js';

/**
 * Returns a callback which given a delta in pixels, will apply the pan interaction and update the state accordingly
 */
export const useApplyPanDelta = () => {
  const { onZoomChange } = useHistogramInteractions();
  const { xScale, initialXScale } = useHistogramXScale();
  const infiniteZoom = useInfiniteZoomConfig();
  const setState = useSetState();

  const initialXDomain = initialXScale.domain();

  return (delta: number) => {
    const [min, max] = getNextPanDomain(
      [initialXDomain[0], initialXDomain[1]],
      xScale,
      -delta,
      false,
      infiniteZoom,
    );

    onZoomChange?.(min, max, 'panning');
    setState(reducePanDomain([min, max]));
  };
};
